export const BEACON_PAGE_LIST = [
  '106240318558522', //BBQ Ticket
  '200701213291845', //Bar B Q Plaza
  '104767375443976' // Line BBQ Ticket
]



// WEBPACK FOOTER //
// ./src/constants/beacon.js